import request from '@/util/request';
import qs from 'qs';

export const getProjects = (params, options) =>
request.get('/api/v4ward/project/getProjectList', Object.assign({}, options, { params }));

export const getMap = (params, options) =>
request.get('/api/v4ward/projectDict/serviceModeList', Object.assign({}, options, { params }));

export const add = (params, options) =>
request.post('/api/v4ward/projectDict/save',  params,options);

export const update = (params, options) =>
request.post('/api/v4ward/projectDict/update',  params,options)

export const remove = (params, options) =>
request.post('/api/v4ward/projectDict/remove',  params,options);

export const getProjectDict = (params, options) =>
  request.get('/api/v4ward/projectDict/dictionary', Object.assign({}, options, { params }));

  export const updateParameter = (params, options) =>
  request.post('/api/v4ward/project/param/update',  params,options)

  export const getProjectParamList = (params, options) =>
  request.get('/api/v4ward/project/param/getProjectParamList', Object.assign({}, options, { params }));
  